<template>
  <div>
    <!--    :on-change="-->
    <!--    (file, fileList)=> {-->
    <!--    return handleChange(file, fileList);-->
    <!--    }-->
    <!--    "-->
    <el-upload
      :auto-upload="false"
      :drag="true"
      class="upload-demo"
      action="#"
      :file-list="fileList"
      :on-change="function (file,fileList){ return handleChange(file,fileList) }"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
    >
      <div
        style="height: 80px"
        class="control-wrapper"
      >
        <div style="line-height: 40px">点击或拖拽文件至虚线框，文件大小不超过4M</div>
        <div>建议添加与此段经历有关的说明文件</div>
      </div>
    </el-upload>
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null"/>
  </div>
</template>

<script>
import {upload} from "@/api/public";
import HBFilePreview from "@/components/HBCommon/HBFilePreview/HBFilePreview.vue";

export default {
  name: 'TabElevenUpdate',
  components: {
    HBFilePreview
  },
  props: {
    fileList: {
      type: Array,
      default() {
        return []
      }
    },
    item: {
      default: null
    }
  },
  data() {
    return {
      previewUrl: null,
      previewName: null
    };
  },
  created() {
  },
  methods: {
    handlePreview(file) {
      this.previewUrl = file.url
      this.previewName = file.name
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.item.fileList = this.fileList
    },
    handleChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 4
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 4MB!')
        this.$nextTick(() => {
          // 移除 fileList 中的最后一个文件（刚刚选择的文件）
          const index = fileList.indexOf(file)
          if (index !== -1) {
            fileList.splice(index, 1)
          }
        })
        return
      }
      if (!file.name.includes('.')) {
        this.$message.error('格式不正确')
        this.$nextTick(() => {
          // 移除 fileList 中的最后一个文件（刚刚选择的文件）
          const index = fileList.indexOf(file)
          if (index !== -1) {
            fileList.splice(index, 1)
          }
        })
        return
      }
      const formser = new FormData() // 获取表单的参数
      formser.append('path', 'admin_file')
      formser.append('file', file.raw)
      upload(formser)
        .then((response) => {
          console.log('上传成功')
          if (!this.item.fileList) {
            this.item.fileList = []
          }
          this.item.fileList.push({ 'name': file.name, 'url': response.data })
          this.$emit('url_data',this.item)
        }).catch((error)=> {
          this.$message.error('上传失败')
        }
      )
    }
  }
}
</script>
<style lang="scss">
.el-upload-list{
  width: 360px;
}
.el-upload-dragger {
  height: 80px !important;
}
.upload-dragger{
  height: 150px !important;
}
.hb-user-profile-edit-page {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .submit-wrapper {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.clear {
  clear: both;
}
.dynamicTags {
  margin-bottom: 1rem;
  border-bottom: 1px solid #dcdcdc;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .my_content {
    flex: 1;
  }
  .icon {
    width: 50px;
    text-align: center;
    font-weight: 900;
    font-size: 25px;
  }
}
.hb-upload-document-dialog {
  .main-wraper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    .left-wrapper {
      flex: 4;
    }
    .right-wrapper {
      flex: 1;
      // width: 30%;
      display: flex;
      flex-direction: column;
      margin: 5px;
      .title {
        color: #333;
        font-weight: 550;
        margin-bottom: 5px;
      }
      .desc {
        color: red;
        margin-bottom: 5px;
      }
    }
  }
  .upload-demo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    .el-upload-list {
      max-width: 100%;
    }
    .control-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .tip-text {
        font-size: 12px;
        color: #909399;
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_eleven_update.vue